import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExerciseContainer } from '../../agenda/agenda.component';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { CandidateModel } from 'projects/runner/src/app/models/candidate.model';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';
import { DataService } from 'projects/runner/src/app/services/data.service';

@Component({
  selector: 'app-agenda-exercise-single',
  templateUrl: './agenda-exercise-single.component.html',
  styleUrls: ['./agenda-exercise-single.component.scss']
})
export class AgendaExerciseSingleComponent implements OnInit {

  @Input() container: ExerciseContainer = null;

  public ac: AcModel = null;
  public acSubscription: Subscription = null;
  public candidate: CandidateModel = null;

  constructor(
    public auth: AuthStateService,
    private data: DataService
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
          this.candidate = this.ac.candidates[0] || null;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
    }
  }

}
